<template>
  <el-dialog title="返佣详情" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <!--form表单-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table :data="form" size="small" border style="width: 100%" v-loading="loading">
          <el-table-column prop="user_id" label="商品信息">
            <template slot-scope="scope">
              <div class="product-info p-10-0">
                <div class="pic"><img v-img-url="scope.row.product_info.product_image" alt="" /></div>
                <div class="info">
                  <div class="name gray3">{{ scope.row.product_info.product_name }}</div>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="money" label="佣金" width="400"></el-table-column>
         
          
        </el-table>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>

export default {
  data() {
    return {
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      loading: false,
      /*是否显示*/
      dialogVisible: false,
     
    };
  },
  props: ['open','form'],
  watch: {
    open: function(n, o) {
      if (n != o) {
        this.dialogVisible = this.open;
       
      }
    }
  },
  created() {
      console.log(this.form);
  },
  methods: {

    /*修改*/
    onSubmit() {
      let self = this;
      self.dialogFormVisible(true);
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('close', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('close', {
          type: 'error',
          openDialog: false
        });
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/agent/order/part/showCommissionDetail.vue